export default __webpack_public_path__ + "static/media/035-walrus.a339ddb6.svg";